module.exports = __webpack_public_path__ + "img/pay-loading.c53ad620.gif";